import { Button } from '@root/core/src/components/button/button';

export * from '@root/core/src/components/button/button';
export * from '@root/core/src/components/button/styles';

export default Button;
